import React, { useState } from "react";
import BG1 from '../../Images/New/Hero/Bg.svg'

function FaqComponent() {
  const [openIndex, setOpenIndex] = useState(-1);

  const toggleItem = (index) => {
    if (openIndex === index) {
      setOpenIndex(-1);
    } else {
      setOpenIndex(index);
    }
  };

  const faqData = [
    {
      question: "What features should I look for in TDS and TCS return filing software?",
      answer:
        "When choosing TDS and TCS return filing software, it's important to look for features such as auto data validation, e-filing and correction of returns, interest calculation, and consolidated Analysis reports. EasyTDS software offers all of these features at an affordable price, making it a top choice for businesses and Tax professionals.",
    },
    {
      question: "Which is the best software to generate revised TDS returns if needed, and how easy is the process?",
      answer:
        " Yes, EasyOFFICE’s EasyTDS software has an eTDS correction module that allows users to generate revised TDS returns if needed. The process is easy and can be done through the software's user-friendly interface.",
    },
    {
      question: "Can I import data from other sources into EasyTDS software, such as Excel or text files?",
      answer:
        "Yes, EasyTDS software allows users to import data from Excel sheets, text files, consolidate (.tds) files.",
    },
    {
      question: "Is there any trial version of the software TDS software?",
      answer:
        "Yes, EasyOFFICE’s EasyTDS provides a free trial version of its software. The trial version is fully functional and allows you to test all the features of the software. To get access to the trial version, you can visit the website and request a demo or download the trial version directly from the website.",
    },
    {
      question: "Which are cost effective options for TDS and TCS return software?",
      answer:
        "There are several TDS and TCS return software providers in the market, but EasyOFFICE’s TDS module stands out with its feature-rich software that comes at an affordable price. EasyTDS also offers free demo trial, allowing users to try out the software before making a purchase.",
    },
  ];

  return (
    <>
      <div
        id="FAQ"
        className="relative sm:flex py-20 px-3 sm:px-12 bg-white items-center justify-center"
      >
        <div className="w-full sm:flex items-center sm:px-5 bg-white border-2 rounded-2xl shadow-xl max-w-7xl">
          <div className="sm:w-[30%]">
            <img src={BG1} alt="" />
          </div>
          <div className="sm:flex sm:w-[70%] items-start px-3 sm:px-12 pb-10">
            <div className="grid w-full px-3 sm:px-0 divide-y divide-neutral-200 mx-auto mt-8">
              {faqData.map((faq, index) => (
                <div className="py-5" key={index}>
                  <details
                    className={`group ${openIndex === index ? "open" : ""}`}
                    open={openIndex === index}
                  >
                    <summary
                      className="flex justify-between text-xl items-center font-medium cursor-pointer list-none"
                      onClick={() => toggleItem(index)}
                    >
                      <span className="sm:px-4 text-lg sm:text-2xl">
                        {faq.question}
                      </span>
                      <div className="transition bg-[#b5d0ff] p-1 rotate-90 mx-4 rounded-full group-open:-rotate-90">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="#00b812"
                          class="bi bi-caret-right-fill w-[16px] h-[16px]"
                          viewBox="0 0 16 16"
                        >
                          <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                      </div>
                    </summary>
                    <p
                      className={`text-gray-900 text-lg sm:text-xl mt-3 sm:px-4 ${
                        openIndex === index ? "fadeIn" : ""
                      }`}
                    >
                      {faq.answer}
                    </p>
                  </details>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* <div className="sm:w-1/2 mt-10 sm:mt-0 px-5">
          <div className="text-center pb-6">
            <p className="mb-2 text-4xl text-black font-extrabold">
              A Word from our <span className="text-[#7decc6]">Customers</span>
            </p>
            <p className="mb-0 text-lg">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Necessitatibus, iusto?
            </p>
          </div>
          <Review />
        </div> */}
      </div>
    </>
  );
}

export default FaqComponent;
